import { Box } from '@mui/material';
import {
  AutomatedInsightSectionToDisplayName,
  AutomatedInsightSections,
} from '../../modules/automated-insights/constants';
import UpgradeSubscriptionPrompt from './UpgradeSubscriptionPrompt';

const ReportContentBlockedScreen = ({ hideReportContent, selectedTab }) => {
  // For pulse owner, if the current selected tab is not part of the user's tier, we block this tab and display a blocking message.
  // If the selected tab is Audience, we don't show this message.
  return hideReportContent &&
    selectedTab !== AutomatedInsightSectionToDisplayName[AutomatedInsightSections.MyAudience] &&
    selectedTab !== AutomatedInsightSectionToDisplayName[AutomatedInsightSections.Audience] &&
    selectedTab !== null ? (
    <Box
      sx={{
        position: 'absolute',
        bottom: 0,
        left: 0,
        right: 0,
        borderRadius: '0 0 20px 20px',
        height: 'max(70%, calc(100vh - 450px))',
        minHeight: '375px', // for mobile when hiding report content
        backgroundColor: '#FFFFFF',
        boxShadow: '0px 1px 8px 0px rgba(0, 0, 0, 0.30)',
        overflowY: hideReportContent ? 'auto' : 'visible', // Add scroll if content exceeds height when fixed
      }}>
      <UpgradeSubscriptionPrompt blockedFeature={selectedTab} />
    </Box>
  ) : (
    <></>
  );
};

export default ReportContentBlockedScreen;
